import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProfile, updateProfile } from "./CompanyProfileAPI";

const initialState = {
  value: 0,
  status: "idle",
  profile: null,
  updateProfileData: {},
};

export const fetchProfileAsync = createAsyncThunk(
  "companyProfile/fetchProfileData",
  async () => {
    try {
      const response = await fetchProfile();
      // console.log("response in thunk:- ", response);
      return response;
    } catch (error) {
      return error
    }
  }
);
export const updateProfileAsync = createAsyncThunk(
  "companyProfile/update",
  async ({uuid, data}) => {
    try {
      const response = await updateProfile(uuid, data);
      // console.log("response in thunk:- ", response);
      return response;
    } catch (error) {
      return error
    }
  }
);


export const companyProfileSlice = createSlice({
  name: "companyProfile",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProfileAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.profile = action.payload.response;
        // console.log("action to payload", state.profile);
      })
      .addCase(updateProfileAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateProfileAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.updateProfileData = action.payload.response;
        // console.log("action.payload :- ", action.payload);
        // console.log("state updateProfile:- ", state.updateProfileData);
      })
  },
});

export const selectCompanyProfile = (state) => state.eDashCmpyProfile.profile;
export const selectComanyProfileStatus = (state) =>
  state.eDashCmpyProfile.status;
// export const selectCompanyUpdate = (state) => state.eDashCmpyProfile.profile;
export default companyProfileSlice.reducer;
